import { apiClient } from './client';

export interface GeneralSetting {
  id: string;
  name: string;
  value: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface BulkUpdateSettingsDto {
  movidesk_api_url?: string;
  movidesk_api_key?: string;
  notification_email_host?: string;
  notification_email_port?: number;
  notification_email_user?: string;
  notification_email_password?: string;
  notification_email_to?: string[];
  enable_notifications?: string;
  contract_notification_usage_percentage?: number;
  contract_notification_days_before_expiration?: number;
}

export const settingsApi = {
  async getAll(): Promise<GeneralSetting[]> {
    const response = await apiClient.get('/general-settings');
    return response.data;
  },

  async getByName(name: string): Promise<GeneralSetting> {
    const response = await apiClient.get(`/general-settings/name/${name}`);
    return response.data;
  },

  async bulkUpdate(settings: BulkUpdateSettingsDto): Promise<GeneralSetting[]> {
    const response = await apiClient.patch('/general-settings/bulk-update', settings);
    return response.data;
  },

  async updateByName(name: string, value: string): Promise<GeneralSetting> {
    const response = await apiClient.patch(`/general-settings/name/${name}`, { value });
    return response.data;
  },
};
